{
  "offerUnavailableToast": {
    "monthly": "This offer isn't available on your plan. Please reach out to support for more info.",
    "gallery": "Galleries isn’t part of the Black Friday offer on your plan. Please reach out to support for more info."
  }
}
